// src/services/companies.ts
import { apiClient } from './api';
import {
  CompanyListItem,
  CompanyDetail,
  CreateCompanyRequest,
  CompanyUser,
  CreateCompanyUserRequest
} from '../types';

class CompaniesService {
  async getAll(): Promise<CompanyListItem[]> {
    const response = await apiClient.get<CompanyListItem[]>('/dashboard/companies');
    return response.data;
  }

  async getById(id: number): Promise<CompanyDetail> {
    const response = await apiClient.get<CompanyDetail>(`/dashboard/companies/${id}`);
    return response.data;
  }

  async create(request: CreateCompanyRequest): Promise<CompanyListItem> {
    const response = await apiClient.post<CompanyListItem>('/dashboard/companies', request);
    return response.data;
  }

  async update(id: number, data: any): Promise<void> {
    await apiClient.put(`/dashboard/companies/${id}`, data);
  }

  async getCompanyUsers(companyId: number): Promise<CompanyUser[]> {
    const response = await apiClient.get<CompanyUser[]>(`/dashboard/companies/${companyId}/users`);
    return response.data;
  }

  async createCompanyUser(companyId: number, request: CreateCompanyUserRequest): Promise<CompanyUser> {
    const response = await apiClient.post<CompanyUser>(`/dashboard/companies/${companyId}/users`, request);
    return response.data;
  }

  async updateCompanyUser(companyId: number, userId: number, data: any): Promise<void> {
    await apiClient.put(`/dashboard/companies/${companyId}/users/${userId}`, data);
  }
}

export const companiesService = new CompaniesService();
